<template>
    <footer class="fixed-footer">
        <slot></slot>
    </footer>
</template>

<script>
    export default {
        name: 'MyFooter',
        props: {
        },
        data: function () {
            return {
            }
        },
        async mounted() {
        },
        components: {
        }
    }
</script>
